import React from "react";
import moment from "moment";

export const CardVacationMap = ({ vacation }) => {
  return (
    <div
      key={vacation._id}
      className="p-calendar-map-pdcs-item"
      style={{ borderColor: "#ec841d", backgroundColor: "#fff1e3", borderWidth: 5 }}
    >
      <div className="p-calendar-map-pdcs-item-date">
        {`Du ${moment(vacation.start_date).format("DD-MM-YYYY HH:mm")} au ${moment(vacation.end_date).format(
          "DD-MM-YYYY HH:mm"
        )}`}
      </div>
      <div className="p-calendar-map-pdcs-item-name">{vacation.title}</div>
    </div>
  );
};



// WEBPACK FOOTER //
// src/containers/activite/map/CardVacationMap.js